import { forwardRef } from 'react';

import { TextField } from '../../base';
import { InputProps } from './types';

/** Fix for ref warning for React Datepicker case @link https://github.com/Hacker0x01/react-datepicker/issues/2165#issuecomment-711032947 */
export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => <TextField {...props} ref={ref} />);
Input.displayName = 'Input';
